import { graphql } from 'src/gql'
import { GetTData } from 'src/gql/helpers'
import { useGraphQL } from 'src/hooks/useGraphQL'

const document = graphql(/* graphql */`
  query distributionSubcategoryNotesById($id: MongoID!) {
    cat {
      distributionSubcategory {
        byId(_id: $id) {
          _id
          notes
        }
      }
    }
  }
`)

type TData = GetTData<typeof document>
export type DistributionSubcategoryNotesById = NonNullable<NonNullable<NonNullable<NonNullable<TData>['cat']>['distributionSubcategory']>['byId']>

const useDistributionSubcategoryNotesById = (id: string): DistributionSubcategoryNotesById | undefined => {
  const { data } = useGraphQL(document, { id }, {
    enabled: typeof id === 'string'
  })
  const distributionSubcategory = data?.cat?.distributionSubcategory?.byId ?? undefined
  return distributionSubcategory
}

export { useDistributionSubcategoryNotesById, document as distributionSubcategoryNotesByIdDocument }
